import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://dummyjson.com", // replace with real API
  headers: {
    "Content-Type": "application/json",
  },
});

/* =========================
   REQUEST INTERCEPTOR
========================= */
axiosInstance.interceptors.request.use(
  (config) => {
    const { protocol } = window.location;

    if (protocol === "https:" && config.url?.startsWith("http:")) {
      config.url = config.url.replace("http:", "https:");
    }

    if (protocol === "http:" && config.url?.startsWith("https:")) {
      config.url = config.url.replace("https:", "http:");
    }

    // attach token if exists
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* =========================
   RESPONSE INTERCEPTOR
========================= */
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 🔴 Unauthorized → logout
      localStorage.removeItem("token");
      //localStorage.removeItem("userId"); // optional
      //localStorage.removeItem("i18nextLng"); // optional

      // reload app (hard refresh)
      window.location.reload();
      // OR redirect instead:
      // window.location.href = "/signIn";
    }

    return Promise.reject(error);
  }
);

export { axiosInstance as axios };
